<!--  -->
<template>
  <div class="container">
    <van-sticky>
      <van-nav-bar style="position: sticky" @click-left="goback" left-arrow fixed title="职位详情"></van-nav-bar>
    </van-sticky>

    <div class="job-wrap">
      <div class="job-info">
        <div class="title-info">
          <div class="title">{{ itemObj.workTypeName }}</div>
          <div class="money">{{ itemObj.salary }}/月</div>
        </div>
        <div class="limit-wrap">
          <div class="limit-info" v-for="(item, index) in itemObj.workRequire" :key="index">
            <span>{{ item }}</span>
          </div>
        </div>
        <div class="date">{{ itemObj.createTime }}发布</div>
      </div>
      <div class="job-company" @click="toCompanyDetail">
        <img
          class="company-img"
          src="https://xianglin003.oss-cn-beijing.aliyuncs.com/active_images/icon-company.png"
          alt
        />
        <div class="company-info">
          <div class="name">{{ itemObj.companyName }}</div>
          <div class="location">
            <img
              src="https://xianglin003.oss-cn-beijing.aliyuncs.com/active_images/icon-dizzhi.png"
              alt
            />
            <span>
              {{ itemObj.workProvinceName }}{{
                itemObj.workCityName
              }}{{ itemObj.detailAddress }}
            </span>
          </div>
        </div>
        <template style="margin-left:10rpx">
          <img
            style="width: 20px; height: 20px"
            src="../../../assets/migrantFiles/icon-in@3x (1).png"
            alt
          />
        </template>
      </div>
    </div>

    <!-- 工作内容 -->
    <div class="work-wrap">
      <div class="work-info">
        <div class="work-title title">
          <div class="title-border"></div>
          <div class="title-txt">工作内容</div>
        </div>
        <div class="content" v-html="itemObj.workContent"></div>
      </div>

      <div class="work-info">
        <div class="work-title title">
          <div class="title-border"></div>
          <div class="title-txt">福利待遇</div>
        </div>
        <div class="content" v-html="itemObj.welfare"></div>
      </div>
      <div style="height: 60px"></div>
    </div>
    <div style="height: 120px"></div>
    <div :class="itemObj.isHire ? 'isHire' : 'submit'" @click="toSignUp">
      <div>{{ itemObj.isHire ? "已报名" : "立即报名" }}</div>
    </div>
  </div>
</template>

<script>
import { getWorkDetail, createUserHireInfo } from "@/api/migrantFiles";
import { Toast } from "vant";
import { Dialog } from 'vant';
export default {
  data() {
    return {
      id: "",
      itemObj: {},
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    console.log(this.$route.query);
    this.id = this.$route.query.id;
    console.log(this.id);
    this.getWorkDetail();
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() { },
  methods: {
    toCompanyDetail() {

      this.$router.push({
        path: "/migrantFiles/companyDetail",
        query: {

          content: this.itemObj.companyIntroduce,
        },
      });
    },
    goback() {
      this.$router.back();
    },
    getWorkDetail() {
      getWorkDetail({ id: this.id }).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.itemObj = res.data;
        } else {
          Toast.loading({
            message: res.message,
            forbidClick: false,
          });
        }
      });
    },
    toSignUp() {
      if (this.itemObj.userIdentity.identity == "node_manager") {
          if (this.itemObj.isHire) {
          return;
        }
        this.$router.push({
          path: "/migrantFiles/selectPersonnel",
          query: {
            id: this.id,
            typeName: "person",
          },
        });
      } else if (this.itemObj.userIdentity.identity == "villager") {
        if (this.itemObj.isHire) {
          return;
        }
        if (!this.itemObj.perfect) {
          Dialog.confirm({
            title: "请先完善求职意向！",
            message: "录入求职信息后可以报名",
            confirmButtonText: "立即去完善",
            cancelButtonText: "取消"
          }).then(() => {
            this.$router.push({
              path: "/migrantFiles/myJobInfo",
              query: { inviteUserId: this.inviteUserId },
            });
          })

          return false;
        }

        Dialog.confirm({
          title: "提示",

          message: "确认报名该岗位?",
        }).then(() => {
          Toast.loading({
            message: "提交中...",
            forbidClick: true,
          });

          let params = {
            identity: "villager",
            workId: this.id,
            byUserId: window.localStorage.getItem("_loginUserId"),
            applicantIds: this.$route.query.applicantId,
            inviteUserId: this.inviteUserId,
          };
          if (params.applicantIds == 0) {
            // applicantIds==0 需要完善基本信息 跳转到 myJobInfo
            Dialog.confirm({
              title: "请先完善求职意向！",
              message: "录入求职信息后可以报名",
              confirmButtonText: "立即去完善",
              cancelButtonText: "取消"
            }).then(() => {
              this.$router.push({
                path: "/migrantFiles/myJobInfo",
                query: { inviteUserId: this.inviteUserId },
              });
            })

            return false;
          }
          createUserHireInfo(params)
            .then((res) => {
              Toast.clear();
              if (res.code == 200) {
                Toast.success({
                  message: "提交成功...",
                  forbidClick: false,
                });
                this.getWorkDetail();
              } else {
                if (res.code == 4001) {
                  Dialog.confirm({
                    title: "请先完善求职意向！",
                    message: "录入求职信息后可以报名",
                    confirmButtonText: "立即去完善",
                    cancelButtonText: "取消"
                  }).then(() => {
                    this.$router.push({
                      path: "/migrantFiles/myJobInfo",
                      query: { inviteUserId: this.inviteUserId },
                    });
                  })
                } else {
                  Toast.fail({
                    message: res.message,
                    forbidClick: false,
                  });
                }

              }
            })
            .catch((err) => {
              Toast.loading({
                message: "加载中...",
                forbidClick: false,
              });
            });
        });
      } else {
      }
    },
  },
};
</script>
<style lang='less' scoped>
/* @import url(); 引入css类 */
.container {
  box-sizing: border-box;
  background: #f7f7f7;
  .job-wrap {
    background: #fff;
    padding: 20px;
    .job-info {
      border-bottom: 1px solid #eeeeee;
      .title-info {
        display: flex;
        justify-content: space-between;
        .title {
          font-size: 16px;
          font-weight: bold;
          color: #333333;
          line-height: 22px;
        }
        .money {
          min-width: 120px;
          font-size: 15px;
          font-weight: bold;
          color: #d70000;
          line-height: 22px;
          text-align: right;
        }
      }
      .limit-wrap {
        display: flex;
        // justify-content: space-between;
        flex-wrap: wrap;
        align-items: center;
        margin-bottom: 5px;
        .limit-info {
          font-size: 14px;
          font-weight: 400;
          color: #7e7d7d;
          margin-top: 5px;
          span {
            margin: 0 10px;
            &:first-child {
              margin-left: 0;
            }
          }
        }
      }
      .date {
        font-size: 14px;
        font-weight: 400;
        color: #696969;
        line-height: 22px;
        min-width: 150px;
        margin-top: 5px;

        text-align: right;
        margin-bottom: 10px;
      }
    }
    .job-company {
      display: flex;
      align-items: center;
      padding: 20px 0 0 0;
      .company-img {
        width: 35px;
        height: 35px;
        margin-right: 10px;
      }
      .company-info {
        width: 82%;
        .name {
          font-size: 14px;
          font-weight: 500;
          color: #343434;
          line-height: 22px;
          margin-bottom: 14px;
          margin-right: 0.6rem;
        }
        .location {
          img {
            width: 10px;
            height: 10px;
          }
          span {
            font-size: 14px;
            font-weight: 300;
            color: #666666;
            line-height: 22px;
              margin-right: 0.6rem;
          }
        }
      }
    }
  }

  .work-wrap {
    background: #fff;
    margin-top: 10px;
    .work-info {
      padding: 0 20px 0px;

      .title {
        display: flex;
        align-items: center;
        .title-border {
          width: 3px;
          height: 9px;
          background: #3699ff;
          border-radius: 3px;
        }
        .title-txt {
          font-size: 15px;
          padding: 15px 0 15px 10px;
          font-weight: 600;
        }
      }
      .content {
        padding-left: 10px;
        font-size: 13px;
        font-weight: 400;
        line-height: 22px;
        color: #777;
        white-space: pre-line;
      }
    }
  }
}
.isHire {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background: #ddd;
  color: #333;
  position: fixed;
  align-items: center;
  width: 100%;
  bottom: 0px;
  height: 50px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.submit {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background: #3699ff;
  color: white;
  position: fixed;
  align-items: center;
  width: 100%;
  bottom: 0px;
  height: 50px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
</style>